import lb from '@/lib/loopback';


export function findFamiliaPublicacoes(settings = {}) {
  return lb
    .find('/FamiliaPublicacoes/', settings);
}

export default {
  findFamiliaPublicacoes,
};
